<template>
  <div>
    <HeroSmall
      :page_title="page_title"
      :leadline="leadline"
    />
    <div class="section">
      <div class="container">
        <div class="row mb-5">
          <div class="col-lg-7">
            <card
              shadow
              body-classes="p-lg-5"
            >
              <!-- error free: {{ error_free }}
              <pre v-html="formErrors"></pre>-->
              <div
                v-if="show_form_submission_complete"
                class="alert alert-success text-center"
                role="alert"
              >
                <span class="lead">
                  Thank you for contacting
                  <br />
                  <strong>HealthView Home Health &amp; Hospice!</strong>
                </span>
              </div>
              <div
                v-if="show_form_submission_error"
                class="alert alert-warning text-center"
                role="alert"
              >
                <span class="lead">
                  Oops... something didn't work correctly.
                  <br />Please call us at
                  <br />
                  <h3 class="h2 font-weight-bold">
                    <a
                      class="text-white"
                      href="tel:1-252-462-2687"
                    >(252) 462-2687</a>
                  </h3>
                </span>
              </div>
              <base-input
                placeholder="Name"
                addon-left-icon="fas fa-user"
                :error="formErrors.name"
                v-model="form.name"
              ></base-input>
              <base-input
                placeholder="Email"
                addon-left-icon="fas fa-envelope"
                :error="formErrors.email"
                v-model="form.email"
              ></base-input>
              <base-input
                placeholder="Phone Number"
                addon-left-icon="fas fa-phone"
                :error="formErrors.phone"
                v-model="form.phone"
              ></base-input>
              <div class="form-group form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="emergency"
                  v-model="emergency"
                />
                <label
                  class="form-check-label h5"
                  for="emergency"
                >
                  This is an
                  <span class="text-warning text-uppercase">Emergency</span>
                </label>
              </div>
              <div v-if="emergency">
                <p class="lead text-center">If this is in emergency please call</p>
                <h3 class="text-center font-weight-bold">
                  <a href="tel:1-252-462-2687">(252) 462-2687</a>
                </h3>
              </div>
              <div
                v-if="!emergency"
                class="form-group"
              >
                <label
                  class="hv_textarea_label"
                  for="form_message"
                >Message</label>
                <textarea
                  class="form-control"
                  id="form_message"
                  rows="3"
                  v-model="form.message"
                ></textarea>
                <div
                  class="text-danger invalid-feedback"
                  style="display: block;"
                  v-if="formErrors.message"
                >{{ formErrors.message }}</div>
              </div>
              <div
                v-if="!emergency"
                class="btn-wrapper text-center"
              >
                <g-recaptcha
                  :data-sitekey="sitekey"
                  :data-validate="checkForm"
                  :data-callback="callback"
                  data-btn-class="btn btn-info"
                >Submit</g-recaptcha>
                <!-- <base-button type="neutral" @click="submitForm">
                        <i class="fas fa-paper-plane"></i>
                        Submit
                </base-button> -->
                <!-- <base-button type="neutral" @click="clearForm">
                        Clear Form
                </base-button>-->
              </div>
            </card>
          </div>
          <div class="col-lg-5">
            <p class="lead">
              For referrals or questions please use the contact form or call us at
              <br />
              <a
                class="h2"
                href="tel:1-252-462-2687"
              >(252) 462-2687</a>
            </p>
            <hr />
            <h5 class="h4 font-weight-bold">
              HealthView
              <br />Home Health &amp; Hospice
            </h5>
            <span>130 S Franklin St, Suite 401</span>
            <br />
            <span>PO Box 7757</span>
            <br />
            <span>Rocky Mount, NC 27804</span>
            <br />
            <span>Fax: (252) 210-2908</span>
            <hr />
            <router-link
              class="btn btn-info btn-block"
              to="/employment"
            >Join Our Team</router-link>
          </div>
        </div>
        <hr />
        <div class="row justify-content-center text-center mt-5">
          <div class="col-xs-12 col-md-8 col-lg-6">
            <div class="card shadow p-2">
              <h3 class="text-center">Emergency/After-hours</h3>
              <span class="h5 text-center">In case of Emergency please call</span>
              <h3 class="h2 text-center font-weight-bold">
                <a href="tel:1-252-462-2687">(252) 462-2687</a>
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { firebase, contactFormRef } from '@/firebase'

import gRecaptcha from '@finpo/vue2-recaptcha-invisible'
import HeroSmall from '../views/components/HeroSmall.vue'
export default {
  name: 'contact-us',
  metaInfo: {
    title: 'Contact',
    meta: [
      {
        'description': 'For referrals or questions on home health care call us at (252) 462-2687 or use the contact form.'
      }
    ]
  },
  components: {
    HeroSmall,
    gRecaptcha
  },
  data () {
    return {
      page_title: 'Contact Us',
      leadline: 'Contact us with your Home Health & Hospice questions.',
      emergency: false,
      something: '',
      form: {
        name: '',
        email: '',
        phone: '',
        message: '',
        recaptcha_token: ''
      },
      email_submitted: '',
      sitekey: process.env.VUE_APP_RECAPTCHA_KEY,
      formErrors: {
        name: '',
        email: '',
        phone: '',
        message: ''
      },
      error_free: false,
      show_form_submission_complete: false,
      show_form_submission_error: false
    }
  },
  methods: {
    submitForm () {
      const obj = {
        ...this.form,
        created_date: firebase.database.ServerValue.TIMESTAMP,
        simple_date: new Date().toLocaleString()
      }
      contactFormRef.push(obj).then(() => {
        this.show_form_submission_complete = true
      }).catch((err) => {
        this.show_form_submission_error = true
      })
      this.clearForm()
    },
    clearForm () {
      this.form = {
        name: '',
        email: '',
        phone: '',
        message: '',
        recaptcha_token: ''
      }
    },
    // validate(){
    //   return true
    // },
    checkForm () {
      this.formErrors = {
        name: '',
        email: '',
        phone: '',
        message: ''
      }

      if (!this.form.name) {
        this.formErrors.name = "Please enter your name."
        this.error_free = false
      } else {
        this.error_free = true
      }
      if (this.form.name && this.form.name.length < 3) {
        this.formErrors.name = "Minimum length of name is 3 letters."
        this.error_free = false
      } else {
        this.error_free = true
      }
      if (!this.form.phone) {
        this.formErrors.phone = "A phone number is required."
        this.error_free = false
      } else {
        this.error_free = true
      }
      if (this.form.phone && this.form.phone.length < 7) {
        this.formErrors.phone = "Minimum length of a phone number is 7 digits."
        this.error_free = false
      } else {
        this.error_free = true
      }
      if (!this.form.email) {
        this.formErrors.email = 'Email required.'
        this.error_free = false
      } else if (!this.validEmail(this.form.email)) {
        this.formErrors.email = 'Valid email required.'
        this.error_free = false
      } else {
        this.error_free = true
      }
      if (!this.form.message) {
        this.formErrors.message = 'Please type your message'
        this.error_free = false
      } else {
        this.error_free = true
      }

      return this.error_free
    },
    validEmail (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    callback (token) {
      // google recaptcha token , then you can pass to backend with your form data .
      if (token) {
        this.form.recaptcha_token = token
        this.submitForm()
      } else {
        // if you use data-size show reCAPTCHA , maybe you will get empty token.
        // console.log('please check you are not robot')
      }
    }
  }
}
</script>
